import { Duration } from 'luxon';

import { durationToHuman } from 'common/utils/formatDate';

// Minimum 1 minute display to avoid showing "0s" or confusing sub-minute values
const MIN_DISPLAY_DURATION_SECONDS = 60;

export const formatActivityDuration = (seconds: number): string =>
    durationToHuman(
        Duration.fromObject({
            seconds: Math.max(seconds, MIN_DISPLAY_DURATION_SECONDS),
        })
            .shiftTo('days', 'hours', 'minutes', 'seconds')
            // Remove seconds for cleaner display
            .set({ seconds: 0 }),
        { unitDisplay: 'narrow' }
    )
        // Remove spaces between numbers and units (e.g. "1 d 5 h" → "1d 5h")
        .replace(/(\d)\s+([a-zA-Z])/g, '$1$2');
